import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { getThemeColors } from '../utils/themeColors';

interface CTACardProps {
  onClose: () => void;
}

const CTACard_4: React.FC<CTACardProps> = ({ onClose }) => {
  const { isDark, isHighContrast } = useTheme();
  const colors = getThemeColors('dark', isDark, isHighContrast);

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent('Olá! Gostaria de fazer uma cotação de seguro auto. Vi as avaliações e fiquei interessado!');
    window.open(`https://wa.me/41764791479?text=${message}`, '_blank');
  };

  return (
    <div style={{
      background: colors.cardBg,
      borderRadius: 16,
      padding: 'clamp(1.5rem, 4vw, 2rem)',
      border: `1px solid ${colors.borderColor}`,
      boxShadow: `0 8px 25px ${colors.shadowColor}`,
      margin: 'clamp(1.5rem, 4vw, 2rem) 0',
      position: 'relative'
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 'clamp(1rem, 3vw, 1.5rem)',
        flexWrap: 'wrap'
      }}>
        {/* Avatar Section */}
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '0.5rem',
          minWidth: '80px'
        }}>
          <div style={{
            width: '60px',
            height: '60px',
            borderRadius: '50%',
            background: `linear-gradient(135deg, ${colors.accentText} 0%, ${colors.primaryText} 100%)`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '1.5rem',
            color: 'white',
            fontWeight: 600
          }}>
            👤
          </div>
          <div style={{
            fontSize: 'clamp(0.7rem, 2vw, 0.8rem)',
            color: colors.secondaryText,
            textAlign: 'center',
            lineHeight: 1.2
          }}>
            Elcio Mattos
          </div>
        </div>

        {/* Content Section */}
        <div style={{ flex: 1, minWidth: '250px' }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            marginBottom: '0.5rem'
          }}>
            <div style={{
              display: 'flex',
              gap: '2px'
            }}>
              {Array.from({ length: 5 }, (_, i) => (
                <span key={i} style={{
                  color: '#FFD700',
                  fontSize: '1rem'
                }}>
                  ★
                </span>
              ))}
            </div>
            <span style={{
              fontSize: 'clamp(0.8rem, 2.2vw, 0.9rem)',
              color: colors.secondaryText,
              fontWeight: 500
            }}>
              • Há 2 anos
            </span>
          </div>

          <blockquote style={{
            fontSize: 'clamp(1rem, 2.8vw, 1.1rem)',
            color: colors.primaryText,
            margin: '0 0 1rem 0',
            lineHeight: 1.4,
            fontStyle: 'italic',
            position: 'relative'
          }}>
            "Muito bom atendimento. Pessoal super eficiente.  Melhor preço do mercado!"
          </blockquote>

          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            marginBottom: '1rem'
          }}>
            <span style={{
              fontSize: 'clamp(0.8rem, 2.2vw, 0.9rem)',
              fontWeight: 600,
              color: colors.accentText
            }}>
              — Elcio Mattos, Blumenau
            </span>
          </div>

          <div style={{
            display: 'flex',
            gap: 'clamp(0.8rem, 2vw, 1rem)',
            flexWrap: 'wrap'
          }}>
            <button
              onClick={handleWhatsAppClick}
              style={{
                background: `linear-gradient(135deg, #25D366 0%, #128C7E 100%)`,
                color: 'white',
                border: 'none',
                borderRadius: 8,
                padding: 'clamp(0.7rem, 2vw, 0.9rem) clamp(1.2rem, 3vw, 1.5rem)',
                fontSize: 'clamp(0.8rem, 2.2vw, 0.9rem)',
                fontWeight: 600,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '0.4rem',
                transition: 'all 0.3s ease',
                boxShadow: '0 3px 10px rgba(37, 211, 102, 0.3)'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 5px 15px rgba(37, 211, 102, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 3px 10px rgba(37, 211, 102, 0.3)';
              }}
            >
              <span style={{ fontSize: '1rem' }}>💬</span>
              Quero Economizar Também
            </button>
            
            <button
              onClick={onClose}
              style={{
                background: 'transparent',
                color: colors.primaryText,
                border: `1px solid ${colors.borderColor}`,
                borderRadius: 8,
                padding: 'clamp(0.7rem, 2vw, 0.9rem) clamp(1.2rem, 3vw, 1.5rem)',
                fontSize: 'clamp(0.8rem, 2.2vw, 0.9rem)',
                fontWeight: 500,
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = colors.borderColor;
                e.currentTarget.style.transform = 'translateY(-1px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'transparent';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              Ver Mais Depoimentos
            </button>
          </div>
        </div>

        {/* Close Button */}
        <button
          onClick={onClose}
          style={{
            background: 'none',
            border: 'none',
            fontSize: '1.2rem',
            color: colors.secondaryText,
            cursor: 'pointer',
            padding: '0.5rem',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.2s ease',
            alignSelf: 'flex-start'
          }}
        >
          ✕
        </button>
      </div>
    </div>
  );
};

export default CTACard_4; 